module.exports = __webpack_public_path__ + "img/xlgd.9067816e.png";